<template>
  <CFooter>
    <div>
      
      <span class="ml-1">&copy; 2020 Spannrit</span>
    </div>
    <div class="ml-auto">
      <span class="mr-1">Powered by</span>
      <a href="https://spannrit.de" target="_blank">Spannrit</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
